import ServicePage from '../servicePage/ServicePage';
import { consultationServiceData } from '../../data/consultationServiceData';

const ConsultationPage = () => {
  return <ServicePage serviceData={consultationServiceData} />;
};

export default ConsultationPage;